export enum MessagePriority {
    Normal = 'normal',
    High = 'high',
}
